import React, { useState } from 'react';

/**
 * SafeImage Component
 * 
 * A wrapper around the <img> tag that handles loading errors by displaying
 * a professional placeholder instead of a broken image icon.
 */
const SafeImage = ({ src, alt, className, style, ...props }) => {
    const [hasError, setHasError] = useState(false);

    const handleError = () => {
        if (!hasError) {
            setHasError(true);
        }
    };

    if (hasError || !src) {
        return (
            <div 
                className={`${className} d-flex flex-column align-items-center justify-content-center bg-light border rounded-3 p-4`}
                style={{ 
                    minHeight: '200px', 
                    color: '#94a3b8',
                    ...style 
                }}
            >
                <svg 
                    width="48" 
                    height="48" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="1.5" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                    className="mb-2 opacity-50"
                >
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                    <circle cx="8.5" cy="8.5" r="1.5" />
                    <polyline points="21 15 16 10 5 21" />
                </svg>
                <span className="small fw-medium text-center">Image Not Available</span>
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={alt}
            className={className}
            style={style}
            onError={handleError}
            {...props}
        />
    );
};

export default SafeImage;
